<template>
    <div class="questionnaire-district">
        <div class="questionnaire-title">{{content}}</div>

        <div class="questionnaire-nationality-content" @click="handleClick">
            <div :class="`questionnaire-nationality-text ${districtName ? 'questionnaire-nationality-text-value' : ''}`">{{districtName ? districtName : '请选择...'}}</div>
            <img :class="`questionnaire-nationality-icon ${isShow ? 'questionnaire-nationality-icon-active' : ''}`" :src="pullPng" alt="">
        </div>
        <van-popup v-model="isShow" position="bottom" :close-on-click-overlay="false">
            <van-cascader :closeable="false" v-model="districtValue" :options="districtOptions" @cancel="handleCancel" @change="handleChange" @finish="handleFinish" />
        </van-popup>
    </div>
</template>

<script>
import pullPng from '@/assets/reserve/questionnaire/pull.png'
import { isEmpty } from '../../../../utils/common'
export default {
    data() {
        return {
            pullPng: pullPng,
            districtValue: "",
            districtName: '',
            isShow: false,
            districtOptions: [],

        }
    },
    props: {
        value: {
            type: Array,
            default: () => {
                return []
            }
        },
        content: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    mounted() {
        if (typeof this.value[0] === 'string') {
            this.districtName = this.value.join('/')
        } else {
            this.districtValue = this.value[2] ? this.value[2].value : undefined
            this.getDistrictList().then((result) => {
                this.districtOptions = result
                if (!isEmpty(this.value[0])) {
                    let districtName = []
                    for (let i = 0; i < result.length; i++) {
                        if (result[i].value === this.value[0].value) {
                            districtName.push(result[i].text)
                            this.getDistrictList(this.value[0].value).then((cityList) => {
                                this.$set(this.districtOptions[i], 'children', cityList)
                                for (let j = 0; j < cityList.length; j++) {
                                    if (cityList[j].value === this.value[1].value) {
                                        districtName.push(cityList[j].text)
                                        this.getDistrictList(this.value[1].value).then((areaList) => {
                                            if (areaList.length) {
                                                this.$set(this.districtOptions[i].children[j], 'children', areaList)
                                                for (let k = 0; k < areaList.length; k++) {
                                                    if (areaList[k].value === this.value[2].value) {
                                                        districtName.push(areaList[k].text)
                                                        this.districtName = districtName.join('/')
                                                    }
                                                }
                                            } else {
                                                this.districtName = districtName.join('/')
                                            }
                                        })
                                        break
                                    }
                                }
                            })
                            break
                        }
                    }

                }
            })
        }
    },
    methods: {
        /**
            获取区域数据
            @param { String } type 类型
            @param { String } code 地区code
            @return
        */
        getDistrictList(code) {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/mldyue/common/district',
                    data: {
                        code: code
                    }
                }).then((res) => {
                    resolve(res.data.list.map((item) => {
                        return {
                            text: item.name,
                            value: item.code
                        }
                    }))
                })
            })
        },
        /**
            级联选择器数据改变事件
            @param 
            @return
        */
        handleChange(event) {
            const { value, tabIndex } = event
            if (tabIndex < 2) {
                this.getDistrictList(value).then((result) => {
                    if (result.length) {
                        for (let i = 0; i < this.districtOptions.length; i++) {
                            const options = this.districtOptions[i]
                            if (options.value === value) {
                                this.$set(this.districtOptions[i], 'children', result)
                                return
                            }
                            if (Array.isArray(options.children) && options.children.length) {
                                for (let j = 0; j < options.children.length; j++) {
                                    const option = options.children[j]
                                    if (option.value === value) {
                                        this.$set(this.districtOptions[i].children[j], 'children', result)
                                        return
                                    }
                                }
                            }
                        }
                    } else {
                        this.handleCancel()
                    }
                })
            } else {
                this.handleCancel()
            }
        },
        /**
            全部选项选择完成后触发
            @param 
            @return
        */
        handleFinish(event) {
            const selectedOptions = event.selectedOptions || []
            let districtName = [], districtValue = []
            for (let i = 0; i < selectedOptions.length; i++) {
                let option = selectedOptions[i]
                districtName.push(option.text)
                districtValue.push({
                    value: option.value,
                    text: option.text
                })
            }
            this.districtName = districtName.join('/')
            this.$emit('change', districtValue)
        },
        /**
            处理点击content事件
            @param 
            @return
        */
        handleClick() {
            if (!this.disabled) {
                this.isShow = true
            }
        },

        /**
            处理popup点击取消事件
            @param 
            @return
        */
        handleCancel() {
            this.isShow = false
        }
    }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/reserve/questionnaire/components/district.vue